// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"82326a9ecc26e159","3817":"8e0ebbb4ff14e93b","5312":"b60163eb7d9a0065","6854":"973e01f2bde66c0d"}[chunkId] + ".css";
};